import MenuDialog from "components/dialog/MenuDialog";

export default function ApontamentoAddDialog({ TipoClass, onClose, ...props }) {
    function getMenuItems() {
        if (TipoClass) {
            return TipoClass.indicadores.map((IndicadorClass) => {
                return {
                    id: IndicadorClass.abbrev,
                    label: IndicadorClass.fullName,
                    Class: IndicadorClass,
                };
            });
        }
    }

    function handleClose(indicador) {
        if (indicador && onClose) {
            onClose(indicador.Class);
        }
    }

    const title = TipoClass ? TipoClass.fullName : null;

    return <MenuDialog title={title} menuItems={getMenuItems()} onClose={handleClose} {...props} />;
}
